import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "borderBottom" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}

import { AlertModalContent } from '@components';
import Icon from '@components/Atoms/Icon/Icon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimetableAlertOverlay',
  props: {
    isOpen: { type: Boolean },
    title: {},
    text: {},
    isMobile: { type: Boolean },
    routeInformationLinkText: {},
    serviceStatusLinkText: {},
    closeCallback: { type: Function },
    redirectCallback: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlayBackdrop",
          role: "dialog",
          "aria-modal": "true",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args))),
          onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args)))
        }, null, 32))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["timetableAlertOverlay", {
        desktopModalView: !_ctx.isMobile,
        mobileModalView: _ctx.isMobile,
        panelActive: _ctx.isOpen
      }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "closeBtn",
          "aria-label": "close timetable alert overlay",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args)))
        }, [
          _createVNode(Icon, {
            "icon-name": "close",
            lg: ""
          })
        ])
      ]),
      _createVNode(_unref(AlertModalContent), {
        "markdown-content": _ctx.text,
        "service-status-link-text": _ctx.serviceStatusLinkText,
        "route-information-link-text": _ctx.routeInformationLinkText,
        onButtonClick: _cache[3] || (_cache[3] = (val) => _ctx.redirectCallback(val))
      }, null, 8, ["markdown-content", "service-status-link-text", "route-information-link-text"])
    ], 2)
  ]))
}
}

})